import { shareColumnsExtend, shareFormColumnsExtend } from './share';
import _ from 'lodash';

const entityColumns = {
  id: {
    model_name: 'FeeRate',
    column_type: 'id',
  },
  created_at: {
    model_name: 'FeeRate',
    column_type: 'datetime',
  },
  updated_at: {
    model_name: 'FeeRate',
    column_type: 'datetime',
  },
  allot_fee: {
    model_name: 'FeeRate',
    column_type: 'string',
  },
  redeem_fee: {
    model_name: 'FeeRate',
    column_type: 'string',
  },
  management_fee: {
    model_name: 'FeeRate',
    column_type: 'string',
  },
  custodian_fee: {
    model_name: 'FeeRate',
    column_type: 'string',
  },
  outsourcing_service_fee: {
    model_name: 'FeeRate',
    column_type: 'string',
  },
  achievement_pay: {
    model_name: 'FeeRate',
    column_type: 'string',
  },
  accrual_time: {
    model_name: 'FeeRate',
    column_type: 'text',
  },
}

export const columnsExtend = (columns, filterColumnsExtend) => {
  return shareColumnsExtend(_.cloneDeep(entityColumns), columns, filterColumnsExtend)
}

export const formColumnsExtend = (columns, { formColumnsConfig = {}, type, data }) => {
  return shareFormColumnsExtend(_.cloneDeep(entityColumns), columns, { formColumnsConfig, type, data })
}
